import { render, staticRenderFns } from "./MerchantList.vue?vue&type=template&id=5bae3538&scoped=true"
import script from "./MerchantList.vue?vue&type=script&lang=js"
export * from "./MerchantList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bae3538",
  null
  
)

export default component.exports